export const getMapTooltipSizeRatio = (scaleFactor?: number): number => {
  if (scaleFactor === 1) {
    return 0.92;
  }

  if (scaleFactor === 0.5) {
    return 0.9;
  }

  return 1;
};
